import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Bot, 
  Users, 
  Newspaper, 
  BarChart3, 
  Settings,
  ChevronLeft,
  Sparkles,
  CreditCard,
  UserCircle,
  Lock,
  Ticket,
  Receipt,
  MessageSquare,
  TrendingUp,
  Smartphone,
  Flag,
  Activity
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const allMenuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Главная', roles: null },
  { path: '/bots', icon: Bot, label: 'Боты', roles: ['administrator', 'tech_admin'] },
  { path: '/users', icon: Users, label: 'Пользователи', roles: null },
  { path: '/news', icon: Newspaper, label: 'Новости', roles: null },
  { path: '/analytics', icon: BarChart3, label: 'Аналитика', roles: ['administrator', 'tech_admin'] },
  { path: '/trackers', icon: Activity, label: 'Трекеры', roles: ['administrator', 'tech_admin'] },
  { path: '/posthog', icon: TrendingUp, label: 'PostHog', roles: ['administrator', 'tech_admin'] },
  { path: '/subscriptions', icon: CreditCard, label: 'Подписки', roles: ['administrator', 'tech_admin'] },
  { path: '/payment-logs', icon: Receipt, label: 'История оплаты', roles: ['administrator', 'tech_admin'] },
  { path: '/certificates', icon: Ticket, label: 'Сертификаты', roles: ['administrator', 'tech_admin'] },
  { path: '/feedback', icon: MessageSquare, label: 'Обратная связь', roles: ['administrator', 'tech_admin'] },
  { path: '/complaints', icon: Flag, label: 'Жалобы', roles: ['administrator', 'tech_admin'] },
  { path: '/group', icon: UserCircle, label: 'Группа', roles: ['administrator', 'tech_admin'] },
  { path: '/settings', icon: Settings, label: 'Настройки', roles: ['administrator', 'tech_admin'] },
  { path: '/miniapp-settings', icon: Sparkles, label: 'MiniApp', roles: ['administrator', 'tech_admin'] },
  { path: '/admin-users', icon: Lock, label: 'Администраторы', roles: ['administrator'] },
  { path: '/app-management', icon: Smartphone, label: 'Приложение', roles: ['administrator', 'tech_admin'] },
];

function Sidebar({ collapsed, onToggle }) {
  const location = useLocation();
  const { user } = useAuth();
  const role = user?.role || 'administrator';

  const menuItems = allMenuItems.filter(item => !item.roles || item.roles.includes(role));

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon">
            <Sparkles size={24} />
          </div>
          {!collapsed && (
            <div className="logo-text">
              <span className="logo-title">Ballet Post</span>
              <span className="logo-subtitle">Manager</span>
            </div>
          )}
        </div>
        <button className="collapse-btn" onClick={onToggle}>
          <ChevronLeft size={18} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <div className="nav-icon">
                <Icon size={20} />
              </div>
              {!collapsed && <span className="nav-label">{item.label}</span>}
              {isActive && <div className="active-indicator" />}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="version-info">
          {!collapsed && <span>v3.0.0</span>}
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
